const ChatPage = {
  ChannelList: 'ChannelList',
  SingleChannelView: 'SingleChannelView',
};

export {
  ChatPage,
};
